import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { ContentElement } from '../../../models/sections-model';

@Directive({
  selector: '[kwSelectableFeatureHelper]'
})
export class SelectableFeatureHelperDirective implements AfterViewInit{
  @Input() contentElement:ContentElement;
  
  constructor(private el:ElementRef<HTMLElement>) { }
  
  ngAfterViewInit(): void {
    console.log(this.contentElement);
    console.log(this.el.nativeElement);
    this.el.nativeElement.style.background = "#CDC";
  }



}
